import { useEffect, useState, useRef } from 'react';
type Options = {
  /**
   * Se novo valor ou valor anterior é null, atualiza sem delay. Padrão: false
   */
  instantaneousNull?: boolean;
  /**
   * Se novo valor é falsy, atualiza imediatamente. Padrão: true
   */
  instantaneousFalsy?: boolean;
  delay: number;
  /**
   * Se última mudança de value foi a mais tempo que delay, Atualiza imediatamente. Padrão: false (era true)
   */
  instantaneousIfOld?: boolean;
};
const useDebounce = function <T>(value: T, delayOrOptions: number | Options): T {
  const delay = typeof delayOrOptions == 'number' ? delayOrOptions : delayOrOptions.delay;
  const instantaneousNull = (typeof delayOrOptions == 'object' && delayOrOptions?.instantaneousNull) ?? false;
  const instantaneousFalsy = (typeof delayOrOptions == 'object' && delayOrOptions?.instantaneousFalsy) ?? true;
  const instantaneousIfOld = (typeof delayOrOptions == 'object' && delayOrOptions?.instantaneousIfOld) ?? false;
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const lastChange = useRef<number>(-1000);
  useEffect(() => {
    const now = Date.now();
    if (instantaneousIfOld && lastChange.current + delay <= now) {
      //update now!
      setDebouncedValue(value);
    } else if (instantaneousFalsy && !value) {
      //update now!
      setDebouncedValue(value);
    } else {
      if (instantaneousNull) {
        setDebouncedValue(v => {
          if (instantaneousNull && (v == null || value == null)) {
            // se o valor anterior é nulo - ou o novo valor é nulo - atualiza instantaneamente
            return value;
          } else {
            return v;
          }
        });
      }
      const handler = setTimeout(() => {
        // se ocorreu a atualização instantânea, isto não vai (ou não deveria) fazer nada
        setDebouncedValue(v => {
          return value;
        });
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    }
  }, [value, delay, instantaneousNull, instantaneousFalsy, instantaneousIfOld]);
  useEffect(() => {
    lastChange.current = Date.now();
  }, [debouncedValue]);
  return debouncedValue;
};
export default useDebounce;